<template>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="confirmState.isOpen"
        class="fixed inset-0 z-[70] flex items-center justify-center p-6"
      >
        <div class="absolute inset-0 bg-black/40" @click="reject" />
        <div
          class="relative w-full max-w-[320px] rounded-[var(--radius-lg)] bg-surface p-5"
          role="alertdialog"
          aria-modal="true"
        >
          <h2 v-if="confirmState.title" class="mb-2 text-[17px] font-bold">
            {{ confirmState.title }}
          </h2>
          <p class="whitespace-pre-line text-[15px] leading-relaxed">{{ confirmState.message }}</p>

          <div class="mt-5 flex gap-2">
            <BaseButton v-if="!confirmState.alertOnly" variant="outline" block @click="reject">
              {{ confirmState.cancelText ?? t('common.button.cancel') }}
            </BaseButton>
            <BaseButton block @click="accept">
              {{ confirmState.confirmText ?? t('common.button.confirm') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useConfirm } from '@/shared/composables/useConfirm'

import BaseButton from '@/shared/ui/base-button.vue'

const { confirmState, accept, reject } = useConfirm()
const { t } = useI18n()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
